import { render, staticRenderFns } from "./SubscriptionOverview.vue?vue&type=template&id=0f2710b2"
import script from "./SubscriptionOverview.vue?vue&type=script&lang=js"
export * from "./SubscriptionOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports